<template>
  <div class="lg:flex max-lg:pt-11">
    <div class="lg:hidden px-2 sm:px-4 py-2.5 flex fixed top-0 left-0">
      <SidebarButtonMenu @click="toggleMenu()" />
    </div>

    <aside v-bind="$attrs" :class="{ 'max-lg:hidden': !isMenuDisplayed }" aria-label="Sidebar">
      <div class="h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-zinc-800">
        <div class="space-y-4 font-medium">
          <div class="pb-7 flex justify-between items-center">
            <div><slot name="logo" /></div>
            <SidebarButtonClose @click="toggleMenu()" />
          </div>
          <div v-for="group in groups" :key="group.title">
            <SidebarSeparator v-if="group.items" />
            <SidebarItem :to="group.link">
              <template #icon><component :is="group.icon" class="w-5 h-5" /></template>
              {{ group.title }}
              <template v-if="group.suffix" #suffix>
                <NuxtLink :to="group.suffix.link"><component :is="group.suffix.icon" class="w-7 h-7" /></NuxtLink>
              </template>
            </SidebarItem>
            <SidebarItem
              v-for="item in group.items"
              :key="item.title"
              :to="item.link"
              :is-active="route.path === item.link"
              :new-tab="item.new_tab"
            >
              {{ item.title }}
            </SidebarItem>
          </div>
        </div>
      </div>
    </aside>

    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  groups: {
    title: string;
    link?: string;
    icon: unknown;
    suffix?: {
      icon: unknown;
      link: string;
    };
    items?: {
      title: string;
      link: string;
      new_tab?: boolean;
    }[];
  }[];
}>();

const route = useRoute();
const isMenuDisplayed = ref(false);
const toggleMenu = useToggle(isMenuDisplayed);
</script>

<style scoped>
aside {
  @apply max-lg:fixed top-0 left-0 z-40 w-64 h-screen transition-transform;

  > div::-webkit-scrollbar {
    display: none;
  }

  svg {
    @apply text-gray-500 transition duration-75 dark:text-gray-400;
  }
}

.content {
  @apply h-screen w-full overflow-y-auto;

  &::-webkit-scrollbar {
    display: thin;
  }
}
</style>

<style>
aside {
  a,
  span {
    @apply text-ellipsis overflow-hidden;
  }
}
</style>
